module.exports = __webpack_public_path__ + "static/media/DoHDA-Logo-Stacked-Black-L.82ddfbd6.png";